import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import api from 'config/api';
import requester from 'utils/requester';
import { getIsLoggedInSelector } from 'reducers/profile/selectors';
import urlHelper from 'helpers/urlhelper';

export const KEY = 'USE_LOAD_RECENT_CHANNELS';

const apiCall = async ({ isLoggedIn }) => {
  const recentEndpoint = urlHelper.getAuthorizedEndpointUrl(api.endpoints.searchChannelPublic, isLoggedIn);

  const { content } = await requester({
    method: 'get',
    url: `${api.host}${recentEndpoint}`,
    params: {
      f_userData: 'recentlyWatched',
      size: 100,
      includeVod: true,
    },
  });

  return content;
};

const useLoadRecentChannels = (options) => {
  const isLoggedIn = useSelector(getIsLoggedInSelector);
  return useQuery([KEY, isLoggedIn], () => apiCall({ isLoggedIn }), { ...options });
};

export default useLoadRecentChannels;
